import React, { useEffect, useState } from 'react'
import './style.css'
import TopBar from '../../components/general/topbar/TopBar';
import Footer from '../../components/general/footer/Footer';
import IGLogo from '../../assets/images/social/instagram-round2.webp'
import FBLogo from '../../assets/images/social/facebook-round2.webp'
import WPLogo from '../../assets/images/social/whatsapp2.webp'
import MPLogo from '../../assets/images/social/maps2.webp'
import DG from '../../assets/datosGenerales.json'
import Banner from '../../assets/images/banners/webps/Iveco.webp'
import { Helmet } from 'react-helmet';

export default function Contact() {

  useEffect(() => {
    window.scroll(0,0);
  })

  const metaTags = {
    title: "Contacto",
    description: "Nicolini Refrigeración es un empresa dedicada a la venta, instalación y reparación de equipos de frío para camiones y utilitarios. Además cuenta con venta de insumos y repuestos para refrigeracion familiar, comercial y del automotor",
    url: "https://www.nicolinirefrigeracion.com.ar/contacto"
  }

  return (
    <div className='Contact'>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" 
        content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={Banner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={Banner} />
      </Helmet>

      <TopBar />
      <div className='Form'>
        <h2>Contactate con nosotros</h2>
        <a href={DG.linkInstagram} target="_blank"><img className='icon' src={IGLogo} />Instagram: <br/>@nicolinirefrigeracionoficial</a>
        <a href={DG.linkFacebook} target="_blank"><img className='icon' src={FBLogo}/>Facebook: <br/>Nicolini Refrigeración</a>
        <a href={DG.linkWhatsApp} target="_blank"><img className='icon' src={WPLogo}/>Cel/WhatsApp: <br/>+54 9 343 417 8703</a>
        <a href={DG.linkMaps} target="_blank"><img className='icon' src={MPLogo}/>Sucursal Crespo: <br/>Av. Pesante 740</a>
      </div>
      <Footer />
    </div>
  )
}